
import React from "react";

const TabLayout = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: "project-files", label: "Project Files", path: "project-files" },
    // { id: "intelligence", label: "Intelligence", path: "intelligence" },
    { id: "bid-readiness", label: "Bid Readiness", path: "bid-readiness" },
    { id: "requirements", label: "Requirements", path: "requirements" },
  ];

  return (
    <div className="flex items-center gap-4 border-b-[1px]">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.path)}
            className={`font-outfit text-[15px] pb-0 px-1 transition-colors ${
              isActive
              ? "text-[#BB42AE] font-semibold border-b-[2px] border-[#BB42AE]"
              : "text-[#707070] font-medium border-transparent hover:text-[#C95EBE]"
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default TabLayout;